var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Collapse",
    {
      staticClass: "tenant-submission-comment-history",
      attrs: { expand: false, withBorder: false },
    },
    [
      _c(
        "div",
        {
          staticClass: "comment-title",
          attrs: { slot: "title" },
          slot: "title",
        },
        [
          _vm._v(
            "\n    " + _vm._s(_vm.$t("tenantProjects.reviewHistory")) + "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _vm.showPM || _vm.histories.length
        ? _c(
            "div",
            {
              staticClass: "comment-contents",
              attrs: { slot: "content" },
              slot: "content",
            },
            [
              _c("div", { staticClass: "tech-comment-content" }, [
                _vm.showPM
                  ? _c("div", { staticClass: "title" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("tenantProjects.submission.pm")) +
                          "\n      "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tech-comment-history" },
                  _vm._l(_vm.histories, function (rec) {
                    return _c(
                      "div",
                      { key: rec.id, staticClass: "clearfix history-item" },
                      [
                        _c("div", { staticClass: "update-history__text" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(rec.createdBy.displayName) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "update-history__text" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._f("formatDate")(
                                  rec.createdAt,
                                  "DD MMM YY HH:mm"
                                )
                              ) +
                              "\n          "
                          ),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }